import { forwardRef } from "react";
import { classNames, Form, FormProps } from "zeta-dom-react";

const WrappedForm = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
    return <Form {...props} ref={ref} className={classNames('eac-form', props.className)} />
});

export { WrappedForm as Form }
export type { FormProps } from "zeta-dom-react";
